import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { EMPTY, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CacheService {
  apiUrl: string = '';
  apiKey: string = '';

  constructor(private http: HttpClient, @Inject(OKTA_AUTH) private auth: OktaAuth, @Inject('CONFIG_SETTINGS') config: any) {
    const configSettings = config['general'];
    this.apiUrl = configSettings['adminApiUrl'];
    this.apiKey = configSettings['apiKey'];
    //this.apiKey = configSettings['apiKey'];
  }

  private getAllItems<T>(url: string): Observable<T[]> {
    const token = this.getToken();
   // const url = this.apiUrl + this.getEndpoint;
    if (token != undefined) {
      return this.http.get<T[]>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }

  private getSingleItem<T>(url: string): Observable<T> {
    const token = this.getToken();
    //const url = this.apiUrl + this.getEndpoint;
    if (token != undefined) {
      return this.http.get<T>(url, this.getHttpOptions(token));
    }
    else {
      return EMPTY;
    }
  }

  private getToken(): string | undefined {
    return this.auth.getAccessToken();
  }

  private getHttpOptions(token: string): object {
    //var headers = new HttpHeaders();
    //headers.append('Content-Type', 'application/json');
    //headers.append('Authorization', 'Bearer ' + token);
    //if (this.apiKey.length > 0) {
    //  headers.append('Ocp-Apim-Subscription-Key', this.apiKey);
    //}

    //const httpOptions = {
    //  headers: headers
    //};

    //return httpOptions;

    if (this.apiKey.length > 0) {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
          'Ocp-Apim-Subscription-Key': this.apiKey
        })
      };
    }
    else {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        })
      };
    }
  }

  getAllUsers(): Promise<StaffItem[]> {
    const url: string = this.apiUrl + 'oneSysCache/staff?take=100000';
    return this.getAllItems<StaffItem>(url).toPromise();
  }

  getCurrentUser(): Promise<StaffItem> {
    const url: string = this.apiUrl + 'oneSysCache/staff/current';
    return this.getSingleItem<StaffItem>(url).toPromise();
  }

  //getCurrentUser(): Promise<StaffItem[]> {
  //  const url: string = this.apiUrl + 'oneSysCache/staff/current';
  //  return this.getAllItems<StaffItem>(url).toPromise();
  //}

  //getPageErrorItems(): Observable<ChangeLogEntry[]> {
  //  const url: string = this.apiUrl + 'core/logs/error';
  //  return this.getAllItems<ChangeLogEntry>(url);
  //}

  //getPageViewItems(): Observable<ChangeLogEntry[]> {
  //  const url: string = this.apiUrl + 'core/logs/page';
  //  return this.getAllItems<ChangeLogEntry>(url);
  //}
}

export interface StaffItem {
  id: string;
  alias: string;
  firstName: string;
  lastName: string;
  fullNameReverse: string;
  emailAddress: string;
  peoplesoftId: string;
  dynamicSignalId: number;
  metrics: { [key: string]: string };
}

